import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/educacao/despesas/listar/form_edit'
import Head from '../../../../../components/head'


function EditarDespesaEducacaoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Despesa da Secretaria Municipal de Educação" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDespesaEducacaoScreen;